/**
 * smarte Reviews — peek carousel for the Judge.me product widget.
 */
(function () {
  const SECTION_SEL = '.smarte-reviews';
  const TRACK_SEL = '.jdgm-rev-widg__reviews';
  const CARD_SEL = '.jdgm-rev, .jdgm-rev-widg__review';

  function unlockCards(track) {
    track.style.height = 'auto';
    track.style.minHeight = '0';
    track.style.maxHeight = 'none';
    track.querySelectorAll(CARD_SEL).forEach((card) => {
      card.style.position = 'relative';
      card.style.left = 'auto';
      card.style.top = 'auto';
      card.style.right = 'auto';
      card.style.transform = 'none';
      card.style.height = 'auto';
    });
  }

  function cardStep(track) {
    const card = track.querySelector(CARD_SEL);
    if (!card) return track.clientWidth;
    const gap = Number.parseFloat(window.getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateArrows(track, nav) {
    if (!nav) return;
    const prev = nav.querySelector('.smarte-reviews__arrow--prev');
    const next = nav.querySelector('.smarte-reviews__arrow--next');
    const max = Math.max(track.scrollWidth - track.clientWidth, 0);
    if (prev) prev.disabled = track.scrollLeft <= 8;
    if (next) next.disabled = track.scrollLeft >= max - 8;
  }

  function placeNav(section, nav) {
    const track = section.querySelector(TRACK_SEL);
    if (!track || !nav) return null;
    nav.hidden = false;
    if (track.nextElementSibling !== nav) {
      track.after(nav);
    }
    return track;
  }

  function enhance(section) {
    const nav = section.querySelector('[data-smarte-reviews-nav]');
    if (!nav || section.dataset.smarteReviewsReady === 'true') {
      placeNav(section, nav);
      return;
    }

    section.dataset.smarteReviewsReady = 'true';

    const bindTrack = (track) => {
      if (!track) return;
      unlockCards(track);
      if (track.dataset.smarteReviewsBound === 'true') {
        updateArrows(track, nav);
        return;
      }
      track.dataset.smarteReviewsBound = 'true';
      track.addEventListener(
        'scroll',
        () => {
          updateArrows(track, nav);
        },
        { passive: true }
      );
      updateArrows(track, nav);
    };

    nav.addEventListener('click', (event) => {
      const button = event.target.closest('.smarte-reviews__arrow');
      if (!button) return;
      const track = section.querySelector(TRACK_SEL);
      if (!track) return;
      const dir = button.classList.contains('smarte-reviews__arrow--next') ? 1 : -1;
      track.scrollBy({ left: dir * cardStep(track), behavior: 'smooth' });
    });

    section.addEventListener('click', (event) => {
      if (!event.target.closest('.jdgm-paginate__page')) return;
      window.setTimeout(() => {
        const track = placeNav(section, nav);
        if (!track) return;
        track.scrollTo({ left: 0 });
        bindTrack(track);
        updateArrows(track, nav);
      }, 350);
    });

    const widget = section.querySelector('.smarte-reviews__widget');
    if (widget) {
      const observer = new MutationObserver(() => {
        const track = placeNav(section, nav);
        if (track) {
          bindTrack(track);
          updateArrows(track, nav);
        }
      });
      observer.observe(widget, { childList: true, subtree: true });
    }

    const track = placeNav(section, nav);
    if (track) bindTrack(track);
  }

  function init(root = document) {
    root.querySelectorAll(SECTION_SEL).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
